import React from 'react';
import PDFCardViewerCarouselZoomFocus from './PDFCardViewerCarouselZoom';

const PDFGrid = ({  data, visibleItems }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2 p-1 border">
      {data.map((lectureitem, index) => (
        <div
          key={index}
          className="relative mb-4 break-inside-avoid overflow-hidden rounded-lg shadow-lg cursor-pointer transition-transform duration-300 hover:scale-100 hover:shadow-xl border-2"
        >
          <PDFCardViewerCarouselZoomFocus pdfUrl={lectureitem.linkmatedrepo} pdfTitulo = {lectureitem.titulo} />
          <a onClick={() => window.location.href = `/lecturas/n/${lectureitem.id}`} className='w-full btn btn-primary rounded-2'>
            Ir a La Lectura
          </a>
        </div>
      ))}
    </div>
  );
};

export default PDFGrid;
